import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { R1FactType } from '@/api/rest/resources/types/fact';
import { WaterHistoricalChart } from '@/components/Charts';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { GraphFact } from '@/components/Charts/types';
import { useNCCardContext } from '@/components/NCCard/NCCard';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';
import { NoData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/components/NoData';

export const WaterCardGraphTile = () => {
  const { t } = useTranslation();
  const { analysisType } = useNCCardContext();

  const chartData = useFact<GraphFact[]>(
    analysisType === 'total'
      ? R1FactType.r1_historic_water_and_soil_moisture_graph
      : R1FactType.r1_historic_water_and_soil_moisture_per_ha_graph,
  )?.value;

  if (!chartData?.length) {
    return <NoData />;
  }

  return (
    <Stack center>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-6 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.water.labels.historicalWHCGraphHeadline')}
          popover={{
            title: t('shared.ncaDetail.details.water.explainers.historicalData.title'),
            body: t('shared.ncaDetail.details.water.explainers.historicalData.body'),
          }}
          className='w-full px-6 sm:px-0'
        />
        <WaterHistoricalChart analysisType={analysisType} data={chartData} showTooltip={true} className='relative' />
      </Stack>
    </Stack>
  );
};
